export default __webpack_public_path__ + "static/book-95950def328350b98d570ed7b14a8d83.png";